import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import '../styles/ExperienceSection.css';

const statsData = [
    { number: 5, labelKey: 'experience.yearsOfExperience' },
    { number: 500, labelKey: 'experience.satisfiedCustomers' },
    { number: 170, labelKey: 'experience.halalDishes' },
    { number: 100, labelKey: 'experience.freshIngredients' },
];

export default function ExperienceSection() {
    const { t } = useTranslation();
    const [ref, inView] = useInView({ triggerOnce: true });

    return (
        <section ref={ref} className="bg-black text-white">
            <div className="stat-container">
                {statsData.map((stat, i) => (
                    <div key={i}>
                        <h2>{inView && <CountUp end={stat.number} duration={2} />}</h2>
                        <p>{t(stat.labelKey)}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
